module.exports = __webpack_public_path__ + "img/mono_37.814a1674.png";